// frontend/src/ShopifyGiftCards/apiClient.js — /api/shopify-gift-cards, same shape as GiftCards/apiClient.js.
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/shopify-gift-cards';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try { const j = await resp.json(); detail = typeof j.detail === 'string' ? j.detail : ''; } catch { /* the status is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}
const send = (method, path, body) => authenticatedFetch(`${BASE}${path}`, { method, headers: { 'Content-Type': 'application/json' }, body: body === undefined ? undefined : JSON.stringify(body) }).then(jsonOrThrow);
const get = (path) => authenticatedFetch(`${BASE}${path}`).then(jsonOrThrow);
const blob = async (path) => { const r = await authenticatedFetch(`${BASE}${path}`); if (!r.ok) await jsonOrThrow(r); return r.blob(); };

export const sgcApi = {
  meta: () => get('/meta'),
  jobs: () => get('/jobs'),
  job: (id) => get(`/jobs/${id}`),
  create: (body) => send('POST', '/jobs', body),
  checkCodes: (body) => send('POST', '/codes/check', body),
  resume: (id) => send('POST', `/jobs/${id}/resume`),
  refresh: (id) => send('POST', `/jobs/${id}/refresh`),
  pdf: (id) => blob(`/jobs/${id}/print.pdf`),
  csv: (id) => blob(`/jobs/${id}/cards.csv`),
  logos: () => get('/logos'),
  logo: (domain) => blob(`/logos/${domain}.png`),
  putLogo: (domain, file) => { const fd = new FormData(); fd.append('file', file); return authenticatedFetch(`${BASE}/logos/${domain}`, { method: 'PUT', body: fd }).then(jsonOrThrow); },
  removeLogo: (domain) => send('DELETE', `/logos/${domain}`),
};

export { openBlob } from '../GiftCards/apiClient';
